import { createSlice } from '@reduxjs/toolkit';

const initialSystemState = {
    slideIdx: 0,
    fixedHeaderTheme: false
};

const systemSlice = createSlice({
    name: 'system',
    initialState: initialSystemState,
    reducers: {
        setSlideIdx: (state, action) => {
            state.slideIdx = action.payload;
        },
        setFixedHeaderTheme: (state, action) => {
            state.fixedHeaderTheme = action.payload;
        }
    }
});

export default systemSlice;

export const { setSlideIdx, setFixedHeaderTheme } = systemSlice.actions;
